import type { QueryKey } from "@tanstack/react-query";

export const PROJECT_QUERY_GC_TIME = 1000 * 60 * 60 * 12;

export const PROJECT_QUERY_STALE_TIMES = {
  detail: 1000 * 60 * 5,
  summary: 1000 * 60 * 15,
  programsInfo: 1000 * 60 * 15,
  folders: 1000 * 60 * 10,
  documents: 1000 * 60 * 10,
  attachments: 1000 * 60 * 10,
  scoringSummary: 1000 * 60 * 5,
  dynamicDraft: 1000 * 60 * 5,
  fundingImpact: 1000 * 60 * 10,
  reference: 1000 * 60 * 60,
} as const;

export const projectQueryKeys = {
  country: "country",
  constraints: "constraints",
  devises: "devises",
  treeCarrier: "tree-carrier",
  docsCarrierProject: "docs-carrier-project",
  indicatorList: "indicator-list",
  esrs: "esrs",
  subcontractors: "project-subcontractors",
  reporting: "project-reporting",
  detail: (projectId: number | string, section: string, version?: number) =>
    `project-${projectId}-${section}${version ? `-v${version}` : ""}`,
  summary: (projectId: number | string) => `project-${projectId}-summary`,
  scoringSummary: (projectId: number | string) =>
    `project-${projectId}-scoring-summary`,
  dynamicDraft: (projectId: number | string) =>
    `project-${projectId}-dynamic-draft`,
  fundingImpact: (projectId: number | string) =>
    `project-${projectId}-funding-impact`,
  attachments: (projectId: number | string) => `project-pjs-${projectId}`,
  folders: (projectId: number | string) => `folders-${projectId}`,
} as const;

const PROJECT_PERSISTED_STATIC_QUERY_ROOTS = new Set([
  projectQueryKeys.country,
  projectQueryKeys.constraints,
  projectQueryKeys.devises,
  projectQueryKeys.treeCarrier,
  projectQueryKeys.docsCarrierProject,
  projectQueryKeys.indicatorList,
  projectQueryKeys.esrs,
  projectQueryKeys.subcontractors,
  projectQueryKeys.reporting,
]);

const PROJECT_PERSISTED_DYNAMIC_QUERY_ROOT_PATTERNS = [
  /^project-\d+-(descriptif|suivi-perf|reporting)(?:-v\d+)?$/,
  /^project-\d+-summary$/,
  /^project-\d+-scoring-summary$/,
  /^project-\d+-dynamic-draft$/,
  /^project-\d+-funding-impact$/,
  /^project-pjs-\d+$/,
  /^folders-\d+$/,
];

export function isProjectPersistedQueryKey(queryKey: QueryKey) {
  if (!Array.isArray(queryKey) || typeof queryKey[0] !== "string") {
    return false;
  }

  const root = queryKey[0];
  if (PROJECT_PERSISTED_STATIC_QUERY_ROOTS.has(root)) {
    return true;
  }

  return PROJECT_PERSISTED_DYNAMIC_QUERY_ROOT_PATTERNS.some((pattern) =>
    pattern.test(root)
  );
}
